// extracted by mini-css-extract-plugin
export default {"emptyContainer":"empty_emptyContainer__n4COJ"};